/**
 * Helper map role row (`/settings/roles`) → `PermissionsMap` cho Redux auth slice.
 * Dùng chung bởi:
 *   - LoginPage: load perms sau khi đăng nhập thành công.
 *   - Layout: re-fetch perms khi page reload (F5) — initial Redux state lấy từ
 *     localStorage có thể stale nếu admin đổi role permissions giữa 2 lần mở.
 */
import type { RolePermissionValue, SettingRole } from '../store/api/settingsApi'
import type { PermissionsMap } from '../store/slices/authSlice'

export const NAV_PERM_KEYS = [
  'purchase',
  'procurement',
  'saleContract',
  'saleControl',
  'factory',
  'virtualWarehouse',
  'futures',
  'position',
  'quality',
  'masterData',
  'setting',
  'factoryBl',
  'factoryNc',
  'factoryNs',
  'factoryNt',
  'factoryPaco',
  'matchingPs',
] as const

/**
 * Encoding canonical (TLC convention) — phải khớp BE
 * `db_value_to_level()` ở `backend/app/services/purchase/permissions.py`:
 *   - `0` → View (read-only)
 *   - `1` → Edit (full CRUD)
 *   - `2` / `null` / undefined → NoGrant (hidden, route-blocked)
 *
 * KHÔNG dùng comparator số trên `RolePermissionValue` — số không có thứ tự
 * (2 = lowest privilege, không phải highest). Dùng string label
 * `'NoGrant' / 'View' / 'Edit'` và RANK trong `usePermission`.
 *
 * Mirror semantics: `SettingsRoleListView.permissionText()`.
 */
export function deriveNavPermissions(role: SettingRole): PermissionsMap {
  const perms: PermissionsMap = {}
  for (const key of NAV_PERM_KEYS) {
    const val = (role as unknown as Record<string, RolePermissionValue | null>)[key]
    perms[key] = val === 1 ? 'Edit' : val === 0 ? 'View' : 'NoGrant'
  }
  return perms
}
